// Vendor imports
const { connect } = require('react-redux')
// Entry imports
const modalActions = require('./actions')
const AuthModal = require('./component-dumb')
const socialProviders = require('./providers')

function mapStateToProps(state) {
  const { authModal } = state
  if (!authModal) {
    return { socialProviders }
  }
  return {
    errorProvider: authModal.errorProvider,
    errorType: authModal.errorType,
    hasAccount: authModal.hasAccount,
    isVisible: authModal.isVisible,
    socialProviders
  }
}

const mapDispatchToProps = {
  onClose: modalActions.hide,
  onHasAccountToggle: modalActions.show,
  onSocialProviderAuth: modalActions.socialAuth
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AuthModal
)
